import { z } from "zod";

const VALID_OTP_LENGTH_MIN = 6;
const VALID_OTP_LENGTH_MAX = 8;
const INVALID_OTP_MESSAGE = `Please enter a valid ${VALID_OTP_LENGTH_MIN}-${VALID_OTP_LENGTH_MAX}-digit code`;

export const verifyOtpFormSchema = z.object({
  otp: z
    .string()
    .min(VALID_OTP_LENGTH_MIN, { message: INVALID_OTP_MESSAGE })
    .max(VALID_OTP_LENGTH_MAX, { message: INVALID_OTP_MESSAGE }),
});

export const enterPhoneNumberFormSchema = z.object({
  phoneNumber: z.string(),
});

export const enterEmailFormSchema = z.object({
  email: z.string().email({ message: "Please enter a valid email address" }),
});
